const nativeFetch = window.fetch.bind(window);
document.addEventListener("DOMContentLoaded", function () {
  const isSkratchCheckout = window.location.href.includes("skratch-checkout");
  if(isSkratchCheckout) {
    appendLipBalmDummySellingPlan()
  } else {
    appendSellingPlanIdToProduct()
  }
  const flowContainer = document.querySelector(".custom-bulk-order-flow");
  if (!flowContainer) return;

  const variantQuantityInputs =
    flowContainer.querySelectorAll(".variant-qty-input");
  const extraInputs = flowContainer.querySelectorAll(".extra-item input");
  const subscriptionInputs = flowContainer.querySelectorAll(".subscription-item input");
  const minusButtons = flowContainer.querySelectorAll(".qty-minus");
  const plusButtons = flowContainer.querySelectorAll(".qty-plus");
  const addToCartButton = document.getElementById("add-to-cart");
  const addToCartDrawerButton = document.getElementById("add-to-cart-drawer");
  const flavorsButton = document.getElementById("select-flavors-button");
  const extrasButton = document.getElementById("select-extras-button");
  const stepVariants = document.getElementById("step-variants");
  const stepExtras = document.getElementById("step-extras");
  const fileInputs = document.querySelectorAll(".upload-design-file");
  const selectedPdfReorder = document.getElementById("selected-re-order-pdf");
  const customerPdfList = document.querySelectorAll(".customer-pdf-list");
  const reorderPdfSelect = document.getElementById("reorder-pdf-select");
  const reorderPdfDropdown = document.getElementById("reorder-pdf-dropdown");
  const reorderPdfMenu = document.getElementById("reorder-pdf-menu");
  const reorderPdfTrigger = reorderPdfDropdown?.querySelector(".custom-dropdown-trigger");
  const reorderPdfItems = reorderPdfMenu?.querySelectorAll(".custom-dropdown-item");
  const extraReorderInput = document.getElementById('extra-item-re-order');
  const purchaseTypeButton = document.getElementById("select-purchase-type-button");
  const subscriptionMultipleFlavors = flowContainer.getAttribute("data-subscription-multiple-flavors");

  // selec file button functionality
  const selectFileButtons = document.querySelectorAll(".select-file-button");
  if (selectFileButtons) {
    selectFileButtons.forEach(selectFileButton => {
      selectFileButton.addEventListener("click", function (event) {
        const inputElement = event.target;
        const previewElm = inputElement.getAttribute('data-target-preview');
        const targetinput = document.getElementById(inputElement.getAttribute('data-target-input'));
        targetinput.setAttribute('data-target-preview', previewElm);
        targetinput.click();
      });
    });
  }

  if (fileInputs) {
    fileInputs.forEach(fileInput => {
      fileInput.addEventListener('change', async function (event) {
        const inputElement = event.target;
        const file = inputElement.files[0]; // Get the first selected file
        const previewElm = inputElement.getAttribute('data-target-preview');
        const uploadButton = document.querySelector(`button[data-target-preview="${previewElm}"]`);
        const extraTarget = uploadButton.getAttribute('data-target-extra');
        const buttonText = uploadButton.textContent;
        uploadButton.textContent = "Uploading...";
        uploadButton.disabled = true;
        if (file) {
          // const fileURL = URL.createObjectURL(file); // Create a URL for the selected file
          // console.log("fileURL", fileURL);
          const fileForm = new FormData()
          fileForm.append('file', file);
          fileForm.append('name', file.name);
          try {
            const getFileUrl = await nativeFetch('https://cqxj5vuftwa2hvmiqrjvzvkgke0waqee.lambda-url.us-east-1.on.aws/upload-file', {
              method: 'POST',
              headers: {
                'x-token': "YkFyb2thaDEzPw=="
              },
              body: fileForm
            })
            const result = await getFileUrl.json();
            if (result && (result.error || !result.fileUrl)) {
              this.value = "";
              uploadButton.textContent = buttonText;
              uploadButton.disabled = false;
              alert("error uploading file");
              throw new Error(result.error);
            }
            const fileUrl = result ? result.fileUrl : ""
            if (extraTarget) {
              const extraInput = document.getElementById(extraTarget);
              if (extraInput) {
                extraInput.dataset.fileUrl = fileUrl;
                uploadButton.textContent = "Change file";
                uploadButton.disabled = false;
              }
            }

            if (file.type === "application/pdf" || file.type === "application/ai" || file.type === "application/postscript") {
              printPDF(previewElm, fileUrl, file.name);
            } else if (file.type === "image/png" || file.type === "image/jpeg") {
              printImage(previewElm, fileUrl);
            } else if (file.name.endsWith('.psd')) {
              const base64Image = result ? result.base64 : "";
              printPSD(previewElm, fileUrl, file.name, base64Image, "upload");
            }
          } catch (error) {
            console.error("error", error);
            this.value = "";
            uploadButton.textContent = buttonText;
            uploadButton.disabled = false;
            alert("error uploading file");
            throw new Error(error);
          }
        } else {
          this.value = "";
          uploadButton.textContent = buttonText;
          uploadButton.disabled = false;
          alert("Please upload a valid PDF file.");
        }
      });
    });
  }

  function getFileExtension(url) {
    // Get the part of the URL before any query parameters or fragments
    const path = url.split('?')[0].split('#')[0];
    // Find the last dot in the path
    const lastDot = path.lastIndexOf('.');
    if (lastDot === -1) {
      return '';
    }
    // Return the substring after the last dot
    return path.substring(lastDot + 1);
  }

  function getFileName(url) {
    try {
      // Create a new URL object from the URL string
      const urlObject = new URL(url);

      // Get the pathname and split it by the '/' delimiter
      const pathSegments = urlObject.pathname.split('/');

      // The last segment of the path should be the file name
      return pathSegments.pop();
    } catch (error) {
      console.error('Invalid URL:', error);
      return null;
    }
  }

  if (customerPdfList.length) {
    customerPdfList.forEach(async (item) => {
      const fileURL = item.getAttribute('data-url');
      const targetPreview = item.getAttribute('data-target-preview');
      if (fileURL && targetPreview) {
        // Wait a bit for the DOM to be ready
        setTimeout(async () => {
          const extension = getFileExtension(fileURL);
          const fileName = getFileName(fileURL);
          if (extension === "pdf" || extension === "ai") {
            await printPDF(targetPreview, fileURL);
          } else if (extension === "png" || extension === "jpeg" || extension === "jpg") {
            await printImage(targetPreview, fileURL);
          } else if (extension === "psd") {
            await printPSD(targetPreview, fileURL, fileName, null, "preview");
          } else {
            await printError(targetPreview, fileName);
          }
        }, 100);
      }
    });
  }

  // Handle custom dropdown functionality
  if (reorderPdfDropdown && reorderPdfTrigger && reorderPdfMenu && reorderPdfItems) {
    let isOpen = false;

    // Reset dropdown to initial state
    function resetDropdown() {
      const triggerText = reorderPdfTrigger.querySelector('.dropdown-text');
      triggerText.innerHTML = 'Select a previous design...';
      triggerText.style.display = 'flex';
      triggerText.style.alignItems = 'center';

      // Clear selection
      reorderPdfItems.forEach(i => i.classList.remove('selected'));

      // Clear stored file URL
      if (extraReorderInput) {
        delete extraReorderInput.dataset.fileUrl;
      }
    }

    // Toggle dropdown
    reorderPdfTrigger.addEventListener('click', function (e) {
      e.stopPropagation();
      isOpen = !isOpen;

      if (isOpen) {
        reorderPdfMenu.classList.add('open');
        reorderPdfTrigger.classList.add('open');
      } else {
        reorderPdfMenu.classList.remove('open');
        reorderPdfTrigger.classList.remove('open');
      }
    });

    // Handle item selection
    reorderPdfItems.forEach(item => {
      item.addEventListener('click', function () {
        const selectedValue = this.dataset.value;
        const selectedText = this.querySelector('.pdf-filename').textContent;

        // Update trigger content
        const triggerText = reorderPdfTrigger.querySelector('.dropdown-text');
        triggerText.innerHTML = '';

        // Create canvas clone for trigger
        const canvasClone = document.createElement('div');
        canvasClone.id = "preview--selected-canvas-wrapper";
        canvasClone.style.width = '40px';
        canvasClone.style.height = '40px';
        canvasClone.style.marginRight = '8px';
        canvasClone.style.display = 'inline-block';
        canvasClone.style.verticalAlign = 'middle';

        // Create text span
        const textSpan = document.createElement('span');
        textSpan.textContent = selectedText;
        textSpan.style.verticalAlign = 'middle';

        // Add elements to trigger
        triggerText.appendChild(canvasClone);
        triggerText.appendChild(textSpan);

        const extension = getFileExtension(selectedValue);
        const fileName = getFileName(selectedValue);
        if (extension === "pdf" || extension === "ai") {
          printPDF("preview--selected-canvas", selectedValue);
        } else if (extension === "png" || extension === "jpeg" || extension === "jpg") {
          printImage("preview--selected-canvas", selectedValue);
        } else if (extension === "psd") {
          const base64Image = item.querySelector('img').src.replace("data:image/png;base64,", "");
          printPSD("preview--selected-canvas", selectedValue, fileName, base64Image, "preview");
        } else {
          printError(targetPreview, fileName);
        }

        // Update hidden input
        if (reorderPdfSelect) {
          reorderPdfSelect.value = selectedValue;
        }

        // Update visual selection
        reorderPdfItems.forEach(i => i.classList.remove('selected'));
        this.classList.add('selected');

        // Close dropdown
        isOpen = false;
        reorderPdfMenu.classList.remove('open');
        reorderPdfTrigger.classList.remove('open');

        // Store selected PDF URL for form submission
        if (extraReorderInput) {
          extraReorderInput.dataset.fileUrl = selectedValue;
        }
      });
    });

    // Close dropdown when clicking outside
    document.addEventListener('click', function (e) {
      if (!reorderPdfDropdown.contains(e.target) && isOpen) {
        isOpen = false;
        reorderPdfMenu.classList.remove('open');
        reorderPdfTrigger.classList.remove('open');
      }
    });
  }

  // print pdf functionality
  async function printPDF(canvasId, fileURL, fileName) {
    let fileNameText = fileName;
    if (!fileName) {
      const urlObject = new URL(fileURL);
      const pathname = urlObject.pathname;
      const filename = pathname.split('/').pop();
      fileNameText = decodeURIComponent(filename);
    }
    const targetPreviewWrapper = document.getElementById(canvasId + '-wrapper');
    const canvas = document.createElement('canvas');
    if (!targetPreviewWrapper) return;
    try {
      pdfjsLib.GlobalWorkerOptions.workerSrc = window?.workerUrl;
      const loadingTask = pdfjsLib.getDocument(fileURL);
      const pdf = await loadingTask.promise;
      const pageNumber = 1; // Or any desired page number
      const page = await pdf.getPage(pageNumber);

      // Check if this is a dropdown canvas (smaller size)
      const isDropdownCanvas = canvasId.includes('pdf-re-order-') || canvasId.includes('preview--selected-canvas');
      const desiredWidth = isDropdownCanvas ? 50 : 65; // px
      const desiredHeight = isDropdownCanvas ? 50 : 65; // px

      const unscaledViewport = page.getViewport({ scale: 1.0 });
      const scaleX = desiredWidth / unscaledViewport.width;
      const scaleY = desiredHeight / unscaledViewport.height;
      const scale = Math.min(scaleX, scaleY); // Adjust scale as needed
      const viewport = page.getViewport({ scale });
      const context = canvas.getContext('2d');
      canvas.height = desiredHeight;
      canvas.width = desiredWidth;
      const renderContext = {
        canvasContext: context,
        viewport: viewport
      };
      const renderTask = page.render(renderContext);
      await renderTask.promise;
      targetPreviewWrapper.innerHTML = '';
      targetPreviewWrapper.appendChild(canvas);
      canvas.style.display = 'inline-block';

    } catch (error) {
      console.error("error print pdf or ai", error);
      const targetPreviewWrapper = document.getElementById(canvasId + '-wrapper');
      const errorPreviewElm = document.createElement('div');
      const errorPreviewElmImg = document.createElement('img');
      const errorPreviewElmText = document.createElement('span');
      errorPreviewElmImg.src = 'https://cdn.shopify.com/s/files/1/0286/0941/3259/files/image-broken.svg?v=1759893789';
      errorPreviewElmText.textContent = fileNameText;
      errorPreviewElm.appendChild(errorPreviewElmImg);
      errorPreviewElm.appendChild(errorPreviewElmText);
      targetPreviewWrapper.innerHTML = '';
      targetPreviewWrapper.appendChild(errorPreviewElm);
    }
  }

  async function printImage(canvasId, fileURL) {
    const targetPreviewWrapper = document.getElementById(canvasId + '-wrapper');
    if (!targetPreviewWrapper) return;
    const imageElement = document.createElement('img');
    imageElement.src = fileURL;
    imageElement.style.width = '50px';
    imageElement.style.display = 'block';
    targetPreviewWrapper.innerHTML = '';
    targetPreviewWrapper.appendChild(imageElement);
  }

  async function printError(canvasId, fileName) {
    const targetPreviewWrapper = document.getElementById(canvasId + '-wrapper');
    const errorPreviewElm = document.createElement('div');
    const errorPreviewElmImg = document.createElement('img');
    const errorPreviewElmText = document.createElement('span');
    errorPreviewElmImg.src = 'https://cdn.shopify.com/s/files/1/0286/0941/3259/files/image-broken.svg?v=1759893789';
    errorPreviewElmText.textContent = fileName;
    errorPreviewElm.appendChild(errorPreviewElmImg);
    errorPreviewElm.appendChild(errorPreviewElmText);
    targetPreviewWrapper.innerHTML = '';
    targetPreviewWrapper.appendChild(errorPreviewElm);
  }

  async function printPSD(canvasId, fileURL, fileName, base64Image, previewType) {
    const targetPreview = document.getElementById(canvasId + '-wrapper');
    const previewElm = document.createElement('div');
    const previewElmImg = document.createElement('img');
    const previewElmText = document.createElement('span');
    if (base64Image) {
      previewElmImg.src = "data:image/png;base64," + base64Image;
      previewElm.appendChild(previewElmImg);
    } else {
      if (previewType === "upload") {
        previewElmImg.src = 'https://cdn.shopify.com/s/files/1/0286/0941/3259/files/image-broken.svg?v=1759893789';
        previewElmText.textContent = fileName;
        previewElm.appendChild(previewElmImg);
        previewElm.appendChild(previewElmText);
      } else {
        const response = await nativeFetch("https://cqxj5vuftwa2hvmiqrjvzvkgke0waqee.lambda-url.us-east-1.on.aws/psd-convert", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "x-token": "YkFyb2thaDEzPw=="
          },
          body: JSON.stringify({ fileUrl: fileURL }),
        });
        const data = await response.json();
        if (response && data.base64) {
          previewElmImg.src = "data:image/png;base64," + data.base64;
          previewElm.appendChild(previewElmImg);
        } else {
          previewElmImg.src = 'https://cdn.shopify.com/s/files/1/0286/0941/3259/files/image-broken.svg?v=1759893789';
          previewElm.appendChild(previewElmImg);
          previewElmText.textContent = fileName;
          previewElm.appendChild(previewElmText);
        }
      }
    }
    targetPreview.innerHTML = '';
    targetPreview.appendChild(previewElm);
  }


  // SPF type filtering functionality
  const conventionalRadio = document.getElementById(
    "active-ingredients-conventional"
  );
  const zincRadio = document.getElementById("active-ingredients-zinc");

  if (conventionalRadio && zincRadio) {
    conventionalRadio.addEventListener("change", function () {
      if (this.checked) {
        filterVariantsBySPFType("conventional");
      }
    });

    zincRadio.addEventListener("change", function () {
      if (this.checked) {
        filterVariantsBySPFType("zinc");
      }
    });

    filterVariantsBySPFType("conventional");
  }

  // Function to filter variants based on SPF type
  function filterVariantsBySPFType(spfType) {
    const variantItems = document.querySelectorAll(".variant-item");
    const spfIndicator = document.getElementById("spf-type-indicator");

    variantItems.forEach((item) => {
      const variantTitle = item
        .querySelector(".variant-title")
        .textContent.toLowerCase();

      if (spfType === "conventional") {
        if (
          variantTitle.includes("zinc") ||
          variantTitle.includes("zinc-based")
        ) {
          item.style.display = "none";
          const qtyInput = item.querySelector(".variant-qty-input");
          if (qtyInput) {
            qtyInput.value = "0";
            item.classList.remove("active");
          }
        } else {
          item.style.display = "block";
        }
      } else if (spfType === "zinc") {
        if (
          variantTitle.includes("zinc") ||
          variantTitle.includes("zinc-based")
        ) {
          item.style.display = "block";
        } else {
          item.style.display = "none";
          const qtyInput = item.querySelector(".variant-qty-input");
          if (qtyInput) {
            qtyInput.value = "0";
            item.classList.remove("active");
          }
        }
      }
    });

    // Update the indicator text
    if (spfIndicator) {
      if (spfType === "conventional") {
        spfIndicator.textContent = "Showing Conventional SPF-15 flavors";
      } else if (spfType === "zinc") {
        spfIndicator.textContent = "Showing Zinc-Based SPF-15 flavors";
      }
    }

    // Count visible variants for debugging
    const visibleCount = Array.from(variantItems).filter(
      (item) => item.style.display !== "none"
    ).length;

    // Show message if no variants are available
    if (visibleCount === 0) {
      if (spfIndicator) {
        spfIndicator.textContent = `No ${spfType} SPF-15 flavors available`;
        spfIndicator.style.color = "#e74c3c";
      }
    } else {
      if (spfIndicator) {
        spfIndicator.style.color = "#27ae60";
      }
    }

    checkNextButton();
  }

  // Handle minus button clicks
  minusButtons.forEach((button) => {
    button.addEventListener("click", function () {
      const variantId = this.dataset.variantId;
      const quantityInput = flowContainer.querySelector(
        `input[name="quantity_${variantId}"]`
      );
      let currentQty = parseInt(quantityInput.value) || 0;

      // Check if this is an SPF product
      const isSPFProduct = conventionalRadio && zincRadio;
      const increment = isSPFProduct ? 150 : 25;

      if (currentQty > 0) {
        currentQty = Math.max(0, currentQty - increment);
        quantityInput.value = currentQty;
        checkNextButton();
      }

      if (currentQty === 0) {
        this.closest(".variant-item").classList.remove("active");
      }
    });
  });

  // Handle plus button clicks
  plusButtons.forEach((button) => {
    button.addEventListener("click", function () {
      const variantId = this.dataset.variantId;
      const quantityInput = flowContainer.querySelector(
        `input[name="quantity_${variantId}"]`
      );
      let currentQty = parseInt(quantityInput.value) || 0;

      // Check if this is an SPF product
      const isSPFProduct = conventionalRadio && zincRadio;
      const increment = isSPFProduct ? 150 : 25;

      currentQty += increment;
      quantityInput.value = currentQty;
      checkNextButton();

      if (!this.closest(".variant-item").classList.contains("active")) {
        this.closest(".variant-item").classList.add("active");
      }
    });
  });

  // Handle quantity input changes (for validation)
  variantQuantityInputs.forEach((input) => {
    input.addEventListener("change", function () {
      let value = parseInt(this.value) || 0;

      // Check if this is an SPF product
      const isSPFProduct = conventionalRadio && zincRadio;
      const increment = isSPFProduct ? 150 : 25;

      // Ensure value is a multiple of the increment
      value = Math.floor(value / increment) * increment;

      // For SPF products, ensure minimum is 150
      if (isSPFProduct && value > 0 && value < 150) {
        value = 150;
      }

      // For SPF products, if value is not 0, ensure it's at least 150
      if (isSPFProduct && value > 0 && value < increment) {
        value = increment;
      }

      this.value = value;
      checkNextButton();
    });
  });

  if (!document.getElementById("next-to-extras")) {
    document
      .getElementById("add-flavors-to-cart")
      .addEventListener("click", function () {
        stepVariants.querySelector("[data-drawer-close]").click();
        updateSelectedVariants();
        checkAddToCartButton();
      });
  } else {
    document
      .getElementById("next-to-payment-type")
      .addEventListener("click", function () {
        stepVariants.querySelector("[data-drawer-close]").click();
        purchaseTypeButton.removeAttribute("disabled");
        updateSelectedVariants();
        checkAddToCartButton();

        setTimeout(() => {
          purchaseTypeButton.click();
        }, 500);
      });
    document
      .getElementById("next-to-extras")
      .addEventListener("click", function () {
        const checkboxes = document.getElementsByName('purchase-type');
        const selectedValues = [];

        for (let i = 0; i < checkboxes.length; i++) {
          if (checkboxes[i].checked) {
            selectedValues.push(checkboxes[i].value);
          }
        }
        if (selectedValues.length === 0) {
          alert("Please select a purchase type");
          return;
        }

        stepVariants.querySelector("[data-drawer-close]").click();
        extrasButton.removeAttribute("disabled");
        updateSelectedVariants();
        checkAddToCartButton();

        setTimeout(() => {
          extrasButton.click();
        }, 500);
      });
  }

  subscriptionInputs.forEach((input) => {
    input.addEventListener("change", function () {
      if (this.checked) {
        const sameNameInputs = flowContainer.querySelectorAll(
          `input[name="${this.name}"]`
        );
        sameNameInputs.forEach((otherInput) => {
          if (otherInput !== this) {
            otherInput.checked = false;
          }
        });
        const purchaseTypeButtonText = purchaseTypeButton.querySelector("span");
        let textPurchaseType = "";
        if(this.value === "subscription-purchase") {
          textPurchaseType = "Subscription Purchase";
          const priceDescription = document.querySelectorAll('.extra-item-price-description');
          console.log("priceDescription", priceDescription);
          priceDescription.forEach((priceDescription) => {
            priceDescription.style.display = 'block';
          });
        } else {
          textPurchaseType = "One Time Purchase";
          const priceDescription = document.querySelectorAll('.extra-item-price-description');
          priceDescription.forEach((priceDescription) => {
            priceDescription.style.display = 'none';
          });
        }
        purchaseTypeButtonText.textContent = textPurchaseType;
      }
    });
  });

  extraInputs.forEach((input) => {  
    input.addEventListener("change", function () {
      if (this.checked) {
        const sameNameInputs = flowContainer.querySelectorAll(
          `input[name="${this.name}"]`
        );
        sameNameInputs.forEach((otherInput) => {
          if (otherInput !== this) {
            otherInput.checked = false;
          }
        });
      }

      // Show/hide upload file section based on setup fee checkbox
      const firstOrderCheckbox = document.getElementById('extra-item-1');
      const reOrderCheckbox = document.getElementById('extra-item-re-order');
      //const firstOrderPdfUpload = document.getElementById('first-order-pdf-upload');
      //const reOrderPdfUpload = document.getElementById('re-order-pdf-upload');

      /*if (firstOrderCheckbox && firstOrderPdfUpload) {
        if (firstOrderCheckbox.checked) {
          firstOrderPdfUpload.style.display = 'flex';
        } else {
          firstOrderPdfUpload.style.display = 'none';
        }
      }
      if (reOrderCheckbox && reOrderPdfUpload) {
        if (reOrderCheckbox.checked) {
          reOrderPdfUpload.style.display = 'flex';
        } else {
          reOrderPdfUpload.style.display = 'none';
        }
      }*/


      // Show/hide dropdown section based on re-order checkbox
      const dropdownSection = document.querySelector('.customer-pdf-list-wrapper');
      if (extraReorderInput && dropdownSection) {
        if (extraReorderInput.checked) {
          dropdownSection.style.display = 'flex';
        } else {
          dropdownSection.style.display = 'none';
          // Reset dropdown when hidden
          if (reorderPdfDropdown && reorderPdfTrigger) {
            resetDropdown();
          }
        }
      }

      updateExtraItems();
    });
  });

  // Add to cart functionality with nested cart lines support
  addToCartDrawerButton.addEventListener("click", addToCartBulkOrder);
  addToCartButton.addEventListener("click", addToCartBulkOrder);

  async function addToCartBulkOrder() {
    const selectedVariants = getSelectedVariants();
    const selectedVariantsItemsNumber = selectedVariants.length;
    const getSelectedExtras = getExtraItems(selectedVariantsItemsNumber);
    const selectedExtras = getSelectedExtras.extraItems;
    const subscriptionPurchaseCheckbox = document.getElementById('subscription-purchase');

    const cartResponse = await nativeFetch("/cart.js");
    const currentCart = await cartResponse.json();

    // if (selectedExtras.length > 0 && getSelectedExtras.isFileMissing) {
    //   const message = `PDF design file is required in order to add to cart.`;
    //   alert(message);
    //   return
    // }

    const labelFinish =
      document.querySelector('input[name="properties[Label Finish]"]:checked')
        ?.value || "";
    const labelPackaging =
      document.querySelector('input[name="properties[Packaging/tube]"]:checked')
        ?.value || "";
    const labelActiveIngredients =
      document.querySelector(
        'input[name="properties[Active Ingredients]"]:checked'
      )?.value || "";

    // Validate minimum quantities
    let totalQuantity = 0;
    let hasInvalidQuantities = false;

    selectedVariants.forEach((variant) => {
      totalQuantity += variant.quantity;

      // Check if this is an SPF product
      const isSPFProduct = conventionalRadio && zincRadio;
      const minPerFlavor = isSPFProduct ? 150 : 25;

      if (variant.quantity > 0 && variant.quantity < minPerFlavor) {
        hasInvalidQuantities = true;
      }
    });

    // Validate minimum quantity per flavor
    if (hasInvalidQuantities) {
      const minPerFlavor = conventionalRadio && zincRadio ? 150 : 25;
      const message = `Minimum quantity per flavor is ${minPerFlavor} units. Please adjust your quantities.`;

      alert(message);
      return;
    }

    // Validate minimum total quantity
    if (totalQuantity < 50) {
      const message = `Minimum total quantity is 50 units. Please add more flavors or increase quantities.`;

      alert(message);
      return;
    }

    // Validate SPF product quantities
    if (conventionalRadio && zincRadio) {
      const invalidVariants = selectedVariants.filter(
        (variant) => variant.quantity < 150
      );
      if (invalidVariants.length > 0) {
        alert(
          "For SPF products, minimum quantity per flavor is 150 units. Please adjust your quantities."
        );
        return;
      }
    }

    if (selectedVariants.length === 0) {
      alert("Please select at least one variant");
      return;
    }

    const lineItemProperties = labelActiveIngredients
      ? { "Active Ingredients": labelActiveIngredients }
      : {
        ...(labelFinish && { "Label Finish": labelFinish }),
        ...(labelPackaging && { "Packaging/tube": labelPackaging }),
      };

    const isSPFProduct = conventionalRadio && zincRadio;
    if(isSPFProduct) {
      lineItemProperties["_is_spf_product"] = "true";
    }

    // Disable the button to prevent multiple clicks
    addToCartButton.disabled = true;
    addToCartButton.textContent = "Adding to Cart...";
    addToCartDrawerButton.disabled = true;
    addToCartDrawerButton.textContent = "Adding to Cart...";

    const _extra_product_id = []
    selectedExtras.forEach((extra) => {
      lineItemProperties["_extra_product_type"] = extra.type;
      _extra_product_id.push(extra.id);
      if (extra.additionalVariantId) {
        const isHaveAdditionalVariantId = _extra_product_id.includes(extra.additionalVariantId);
        if (!isHaveAdditionalVariantId) {
          _extra_product_id.push(extra.additionalVariantId);
        }
      }
    });
    lineItemProperties["_extra_product_id"] = JSON.stringify(_extra_product_id.sort());
    // First, add all selected variants to cart
    let sellingPlanId = "";

    if (subscriptionPurchaseCheckbox.checked) {
      const subscriptionOption = document.getElementById('subscription-option');
      const subscriptionOptionValue = subscriptionOption.value.replace("gid://shopify/SellingPlan/", "");
      sellingPlanId = subscriptionOptionValue;
      if (!subscriptionOptionValue) {
        alert("Please select a delivery frequency");
        return;
      }
      if (currentCart.items.length > 0) {
        const onCartProductItems =
          currentCart.items.filter(
            (item) => selectedVariants.some(
              (variant) => {
                const sameId = variant.productId == item.product_id
                const isHaveSubscription = item.selling_plan_allocation ? true : false;
                return sameId && isHaveSubscription;
              }
            )
          );
        if (onCartProductItems.length > 0) {
          sellingPlanId = onCartProductItems[0].selling_plan_allocation.selling_plan.id;
        }
      }
    }
    console.log("selectedVariants ===>", selectedVariants);
    let variantItems = [];
    if (subscriptionMultipleFlavors === "true" && subscriptionPurchaseCheckbox.checked) {
      for (const variant of selectedVariants) {
        const flavorTitle = variant.title.replace("Conventional / ", "").replace("Zinc - Based / ", "");
        lineItemProperties["Flavor - " + flavorTitle] = variant.quantity;
        lineItemProperties["_SKU_" + flavorTitle] = variant.sku;
      }
      lineItemProperties["_Total_Flavors"] = selectedVariants.length;
      lineItemProperties["_product_id"] = selectedVariants[0].productId;
      lineItemProperties["_multiple_flavor"] = "true";
      
      // Find default variant ID
      const defaultVariantId = flowContainer.querySelector("#default-variant");
      
      variantItems = [{
        id: defaultVariantId ? defaultVariantId.value : selectedVariants[0].id,
        quantity: totalQuantity,
        properties: lineItemProperties,
        selling_plan: sellingPlanId
      }];
    } else {
      lineItemProperties["_Total_Flavors"] = 1;
      variantItems = selectedVariants.map((variant) => ({
        id: variant.id,
        quantity: variant.quantity,
        properties: lineItemProperties,
        selling_plan: sellingPlanId
      }));
    }

    // Add variants to cart first
    addVariantsToCart(variantItems, selectedExtras, currentCart);
  }

  // Function to add variants to cart first, then add extras as nested items
  async function addVariantsToCart(variantItems, selectedExtras, currentCart) {
    try {
      // Add variants to cart
      const subscriptionPurchaseCheckbox = document.getElementById('subscription-purchase');
      const sameProductItems = currentCart.items.find((item) =>
        variantItems.some((variant) => {
          const sameId = variant.properties._product_id == item.product_id;
          const itemSubscriptionId = item.selling_plan_allocation
            ? item.selling_plan_allocation.selling_plan.id
            : null;
          const sameSubscription = subscriptionPurchaseCheckbox.checked && itemSubscriptionId ? true : false;
          return sameId && sameSubscription;
        })
      );

      let cartCount = 0;
      console.log("subscriptionMultipleFlavors ====>", subscriptionMultipleFlavors);
      console.log("sameProductItems ====>", sameProductItems);
      if (subscriptionMultipleFlavors === "true" && sameProductItems !== undefined) {
        const responseUpdateCartItem = await updateCartItem(variantItems, sameProductItems);
        cartCount = responseUpdateCartItem.item_count;
      } else {
        const response = await nativeFetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ items: variantItems }),
        });

        const data = await response.json();
        cartCount = data.item_count;
        if (data.status) {
          throw new Error("Error adding variants to cart: " + data.description);
        }
      }

      // If there are extras, add them as nested items
      if (selectedExtras.length > 0) {
        console.log("selectedExtras more than 0");
        // Wait a moment for the cart to fully process the parent items
        await new Promise((resolve) => setTimeout(resolve, 1000));
        await addExtrasAsNestedItems(selectedExtras, variantItems, currentCart);
      }

      // Update cart count and trigger drawer
      stepExtras.querySelector("[data-drawer-close]").click();
      updateCartCount(cartCount);
      triggerCartDrawer();
    } catch (error) {
      alert("Error adding to cart: " + error.message);
    } finally {
      resetAddToCartButton();
    }
  }

  // Update extra cart items
  async function updateCartItem(variantItems, targetItemOnCart) {
    try {
      const targetProperties = { ...targetItemOnCart.properties };
      const newProperties = { ...variantItems[0].properties };

      for (const [key, value] of Object.entries(newProperties)) {
        if (key.startsWith('Flavor')) {
          targetProperties[key] = (targetProperties[key] || 0) + value;
        } else if (key.startsWith('_uuid')) {
          targetProperties[key] = targetProperties['_uuid'];
        } else {
          targetProperties[key] = value;
        }
      }

      const targetPropertiesSorted = Object.keys(targetProperties)
        .sort() // sorts alphabetically
        .reduce((acc, key) => {
          acc[key] = targetProperties[key];
          return acc;
        }, {});

      const totalQtyFlavor = Object.entries(targetProperties)
        .filter(([key]) => key.startsWith('Flavor'))
        .reduce((sum, [, value]) => sum + value, 0);

      const totalFlavors = Object.entries(targetProperties)
        .filter(([key]) => key.startsWith('Flavor')).length;
      console.log("totalFlavors ====>", totalFlavors);
      targetPropertiesSorted["_Total_Flavors"] = totalFlavors;

      const updatedVariantItems = {
        id: targetItemOnCart.key,
        quantity: totalQtyFlavor,
        properties: targetPropertiesSorted,
        selling_plan: variantItems.selling_plan
      };

      const updateCartItemResponse = await nativeFetch("/cart/change.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(updatedVariantItems),
      });
      const updateCartItemData = await updateCartItemResponse.json();

      return updateCartItemData;
    } catch (error) {
      alert("Error updating cart item: " + error.message);
      console.error("Error updating cart item", error);
    }
  }

  // Function to add extras as properties-based items
  async function addExtrasAsNestedItems(selectedExtras, variantItems) {
    try {
      console.log("addExtrasAsNestedItems");
      const cartResponse = await nativeFetch("/cart.js");
      const currentCart = await cartResponse.json();
      console.log("currentCart ====>", currentCart);
      console.log("variantItems ====>", variantItems);
      // Get subscription ID from variant items for comparison
      const currentSubscription = variantItems[0]?.selling_plan
        ? true
        : false;
      console.log("currentSubscriptionId ====>", currentSubscription);
      const existingExtras = currentCart.items.filter((item) =>
        selectedExtras.some((extra) => {
          // Check if same variant ID
          const sameId = extra.id == item.variant_id;

          // Check if same subscription
          const itemSubscriptionId = item.selling_plan_allocation
            ? item.selling_plan_allocation?.selling_plan?.id
            : null;
          const sameSubscription = (currentSubscription && itemSubscriptionId) ||
            (!currentSubscription && !itemSubscriptionId);
          return sameId && sameSubscription;
        })
      );
      console.log("existingExtras ====>", existingExtras);
      const existingProducts = currentCart.items.filter((item) => {
        const sameId = Number(item.product_id) === Number(variantItems[0].properties._product_id)
        const itemSubscriptionId = item.selling_plan_allocation
          ? item.selling_plan_allocation?.selling_plan?.id
          : null;
        const sameSubscription = (currentSubscription && itemSubscriptionId) ||
          (!currentSubscription && !itemSubscriptionId);
        return sameId && sameSubscription;
      });
      console.log("existingProducts ====>", existingProducts);

      const selectedVariants = getSelectedVariants();
      console.log("selectedVariants ====>", selectedVariants);
      // Get the first selected variant's title for parent product name
      const parentProductId = Number(selectedVariants[0]?.productId);
      const isSPFProduct = conventionalRadio && zincRadio;
      const parentProductTitle =
        selectedVariants.length > 0
          ? isSPFProduct
            ? selectedVariants[0].title
            : selectedVariants[0].productTitle
          : "Custom Bulk Order";
      console.log("parentProductTitle ====>", parentProductTitle);
      let subscriptionInterval = "";
      if (window.mainSellingPlanGroup) {
        const selectedSubscriptionOption = window.mainSellingPlanGroup.find(
          sellingPlan => sellingPlan.node.id.replace("gid://shopify/SellingPlan/", "") === variantItems[0].selling_plan
        );
        subscriptionInterval = selectedSubscriptionOption?.node?.billingPolicy?.intervalCount;
      }
      console.log("subscriptionInterval ====>", subscriptionInterval);
      let totalFlavors = 0;
      existingProducts.forEach((product) => {
        totalFlavors += parseInt(product.properties._Total_Flavors);
      });
      console.log("totalFlavors ====>", totalFlavors);
      if (existingExtras.length > 0) {
        if (totalFlavors > 1) {
          const additionalExtrasOnCart = currentCart.items.find((item) => {
            const sameId = Number(item.properties._parent_product_id) === Number(variantItems[0].properties._product_id) && item.properties._extra_product_type === "additional";
            const itemSubscriptionId = item.selling_plan_allocation
              ? item.selling_plan_allocation.selling_plan.id
              : null;
            const sameSubscription = (currentSubscription && itemSubscriptionId) ||
              (!currentSubscription && !itemSubscriptionId);
            return sameId && sameSubscription;
          });
          console.log("additionalExtrasOnCart ====>", additionalExtrasOnCart);
          console.log("existingProducts ====>", existingProducts);
          const extraQty = totalFlavors - 1;
          if (additionalExtrasOnCart) {
            await updateExtraQuantity(additionalExtrasOnCart.key, extraQty);
          } else {
            for (const extra of selectedExtras) {
              if (extra.additionalVariantId && totalFlavors > 1) {
                await addExtraWithPropertiesOnly(extra.additionalVariantId, extraQty, {
                  "_is_nested": "true",
                  "_parent_item_type": "custom_bulk_product",
                  "_parent_product_id": parentProductId,
                  "_extra_product_type": "additional",
                  "_extra_additional_variant_id": extra.additionalVariantId,
                  "Parent Product": parentProductTitle,
                  "Custom Balm File": ""
                }, subscriptionInterval, extra.productId);
              }
            }
          }
        }
        return; // Skip if extras already exist
      }

      // If no specific parent found, use any non-extra product
      // if (parentItems.length === 0) {
      //   parentItems.push(...currentCart.items.filter((item) => {
      //     const isExtra = selectedExtras.some((extra) => extra.id == item.variant_id);
      //     return !isExtra && item.quantity > 0;
      //   }));
      // }

      // if (parentItems.length === 0) {
      //   return; // No parent items available
      // }

      // Add extras using properties-only approach
      for (const extra of selectedExtras) {
        try {
          await addExtraWithPropertiesOnly(extra.id, extra.qty, {
            "_is_nested": "true",
            "_parent_item_type": "custom_bulk_product",
            "_parent_product_id": parentProductId,
            "_extra_product_type": extra.type,
            "_extra_additional_variant_id": extra.additionalVariantId,
            "Parent Product": parentProductTitle,
            "Custom Balm File": extra.fileUrl || ""
          }, subscriptionInterval, extra.productId);
        } catch (error) {
          // Continue with other extras even if one fails
        }
      }

      // Trigger cart refresh
      const cartRefreshEvent = new CustomEvent('cart:updated');
      document.dispatchEvent(cartRefreshEvent);

      setTimeout(async () => {
        try {
          if (window.refreshCartDrawer) {
            await window.refreshCartDrawer();
          } else if (window.bulkCartLogic && window.bulkCartLogic.refreshCartDrawer) {
            await window.bulkCartLogic.refreshCartDrawer();
          }

          if (window.updateCartCountState) {
            window.updateCartCountState();
          } else if (window.bulkCartLogic && window.bulkCartLogic.updateCartCountState) {
            window.bulkCartLogic.updateCartCountState();
          }
        } catch (error) {
          // Silent error handling
        }
      }, 500);

    } catch (error) {
      // Silent error handling
    }
  }

  // Helper function to add update extra
  async function updateExtraQuantity(extraId, extraQty) {
    try {
      const body = {
        id: extraId,
        quantity: extraQty
      }
      const response = await nativeFetch("/cart/change.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(body),
      });

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`HTTP ${response.status}: Failed to add extra item (properties-only): ${errorText}`);
      }

      const result = await response.json();
      return result;
    } catch (error) {
      throw error;
    }
  }
  // Helper function to add extras with properties
  async function addExtraWithPropertiesOnly(
    extraId, extraQty, extraProperties, subscriptionInterval, extraProductId) {
    try {
      console.log("addExtraWithPropertiesOnly");
      console.log("subscriptionInterval====>", subscriptionInterval);
      console.log("window.extraSellingPlans====>", window.extraSellingPlans); 
      console.log("extraProductId====>", extraProductId);
      const extraSubscriptionGroup =
        subscriptionInterval && window.extraSellingPlans ?
          window.extraSellingPlans.find(sellingPlan =>
            sellingPlan.id.replace("gid://shopify/Product/", "") === extraProductId
          ) : "";
          console.log("extraSubscriptionGroup====>", extraSubscriptionGroup);
      const extraSubscriptionId =
      extraSubscriptionGroup?.sellingPlans?.find(sellingPlan =>
            sellingPlan.node.billingPolicy.intervalCount === subscriptionInterval
          ) || "";
          console.log("extraSubscriptionId====>", extraSubscriptionId);
      const requestBody = {
        items: [{
          id: extraId,
          quantity: extraQty,
          selling_plan: extraSubscriptionId ? extraSubscriptionId.node.id.replace("gid://shopify/SellingPlan/", "") : "",
          properties: {
            ...extraProperties,
            "_nested_cart_lines_bypassed": "true",
          }
        }]
      };
      const response = await nativeFetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestBody),
      });

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`HTTP ${response.status}: Failed to add extra item (properties-only): ${errorText}`);
      }

      const result = await response.json();
      console.log("result add extra with properties only====>", result);
      return result;
    } catch (error) {
      throw error;
    }
  }

  function resetAddToCartButton() {
    addToCartButton.disabled = false;
    addToCartButton.textContent = "Add to Cart";
    addToCartDrawerButton.disabled = false;
    addToCartDrawerButton.textContent = "Add to Cart";
  }

  function updateCartCount(count) {
    // Update cart count display
    const cartCountElements = document.querySelectorAll("[data-cart-count]");
    cartCountElements.forEach((element) => {
      element.textContent = count;
    });
  }

  function triggerCartDrawer() {
    // Fetch and update cart drawer content
    if (window.T4SThemeSP && window.T4SThemeSP.getToFetchSection) {
      window.T4SThemeSP.getToFetchSection("?section_id=mini_cart")
        .then((response) => {
          if (response && response !== "NVT_94") {
            // Update the cart drawer content
            const cartDrawer = document.querySelector("#t4s-mini_cart");
            if (cartDrawer) {
              cartDrawer.innerHTML = response;
            }
          }

          // Trigger cart update events
          document.dispatchEvent(
            new CustomEvent("cart:updated", {
              detail: {
                count:
                  document.querySelector("#t4s-mini_cart")?.dataset.ccount || 0,
              },
              bubbles: true,
              cancelable: true,
            })
          );

          // Update cart count state for bulk cart logic
          if (window.updateCartCountState) {
            window.updateCartCountState();
          } else if (
            window.bulkCartLogic &&
            window.bulkCartLogic.updateCartCountState
          ) {
            window.bulkCartLogic.updateCartCountState();
          } else if (window.handleInitialAddToCart) {
            window.handleInitialAddToCart();
          }

          // Try to trigger the cart drawer using the theme's method
          if (window.t4s && window.t4s.cart && window.t4s.cart.updateDrawer) {
            window.t4s.cart.updateDrawer();
          } else if (
            window.t4s &&
            window.t4s.cart &&
            window.t4s.cart.openDrawer
          ) {
            window.t4s.cart.openDrawer();
          } else {
            // Fallback: trigger the drawer manually
            const cartDrawer = document.querySelector("#t4s-mini_cart");
            if (cartDrawer) {
              // Trigger drawer open
              const drawerTrigger = document.querySelector(
                '[data-drawer-options*="t4s-mini_cart"]'
              );
              if (drawerTrigger) {
                drawerTrigger.click();
              } else {
                // Last resort: show the drawer directly
                cartDrawer.classList.add("t4s-drawer--open");
                document.body.classList.add("t4s-drawer-open");
              }
            }
          }
        })
        .catch((error) => {
          console.error("Error fetching cart content:", error);
          // Fallback: try to open drawer anyway
          const cartDrawer = document.querySelector("#t4s-mini_cart");
          if (cartDrawer) {
            const drawerTrigger = document.querySelector(
              '[data-drawer-options*="t4s-mini_cart"]'
            );
            if (drawerTrigger) {
              drawerTrigger.click();
            }
          }
        });
    } else {
      // Fallback if theme functions not available
      const cartDrawer = document.querySelector("#t4s-mini_cart");
      if (cartDrawer) {
        const drawerTrigger = document.querySelector(
          '[data-drawer-options*="t4s-mini_cart"]'
        );
        if (drawerTrigger) {
          drawerTrigger.click();
        }
      }
    }
  }

  function checkNextButton() {
    const selectedVariants = getSelectedVariants();
    const nextButton =
      document.getElementById("next-to-extras") ||
      document.getElementById("add-flavors-to-cart");
    const nextButtonPaymentType = document.getElementById("next-to-payment-type");

    // Count total quantity from selected variants
    const totalQuantity = selectedVariants.reduce(
      (sum, variant) => sum + variant.quantity,
      0
    );

    // Disable button if total quantity less than 50
    nextButton.disabled = totalQuantity < 50;
    nextButtonPaymentType.disabled = totalQuantity < 50;
  }

  function checkAddToCartButton() {
    const selectedVariants = getSelectedVariants();
    const purchaseOptions = document.getElementsByName('purchase-type');
    let selectedPurchaseOption = [];

    for (let i = 0; i < purchaseOptions.length; i++) {
      if (purchaseOptions[i].checked) {
        selectedPurchaseOption.push(purchaseOptions[i].value);
      }
    }

    addToCartButton.disabled = selectedVariants.length === 0 || selectedPurchaseOption.length === 0;
    addToCartDrawerButton.disabled = selectedVariants.length === 0 || selectedPurchaseOption.length === 0;
  }

  function getSelectedVariants() {
    const selected = [];

    variantQuantityInputs.forEach((input, index) => {
      const quantity = parseInt(input.value) || 0;

      if (quantity > 0) {
        // Check if the variant item is visible
        const variantItem = input.closest(".variant-item");
        if (variantItem && variantItem.style.display !== "none") {
          // Try to get variant ID from various possible sources
          let variantId =
            input.dataset.variantId ||
            input.dataset.variantid ||
            input.getAttribute("data-variant-id") ||
            input.getAttribute("data-variantid");

          // If still no variant ID, try to get it from the input name
          if (!variantId && input.name && input.name.includes("quantity_")) {
            variantId = input.name.replace("quantity_", "");
          }

          // Try to get title from various possible sources
          let title =
            input.dataset.variantTitle ||
            input.dataset.varianttitle ||
            input.getAttribute("data-variant-title") ||
            input.getAttribute("data-varianttitle");

          let productTitle =
            input.dataset.productTitle ||
            input.dataset.producttitle ||
            input.getAttribute("data-product-title") ||
            input.getAttribute("data-producttitle");

          let productId =
            input.dataset.productId ||
            input.dataset.productid ||
            input.getAttribute("data-product-id") ||
            input.getAttribute("data-productid");

          let sku =
            input.dataset.sku ||
            input.dataset.sku ||
            input.getAttribute("data-sku") ||
            input.getAttribute("data-sku");

          if (variantId) {
            selected.push({
              id: variantId,
              title: title || `Variant ${variantId}`,
              productTitle: productTitle || `Product ${variantId}`,
              productId: productId,
              quantity: quantity,
              sku: sku,
            });
          } else {
            console.warn(`No variant ID found for input ${index}:`, input);
          }
        }
      }
    });

    return selected;
  }

  function updateSelectedVariants() {
    const selectedVariants = getSelectedVariants();
    const numberOfFlavors = selectedVariants.length;
    let totalUnits = 0;
    selectedVariants.forEach((variant) => {
      totalUnits += parseInt(variant.quantity);
    });

    flavorsButton.querySelector(
      "span"
    ).textContent = `Total Units ${totalUnits} / No. of Flavors ${numberOfFlavors}`;
  }

  function getExtraItems(selectedVariantsItemsNumber) {
    const extraItems = [];
    let isFileMissing = false;
    extraInputs.forEach((checkbox, index) => {
      if (checkbox.checked) {
        const fileUrl = checkbox.dataset.fileUrl
        const isNeedFile = checkbox.dataset.fileRequired
        if (isNeedFile && !fileUrl) {
          isFileMissing = true
        }

        // Try to get title from various possible sources
        let title =
          checkbox.dataset.variantTitle ||
          checkbox.dataset.varianttitle ||
          checkbox.getAttribute("data-variant-title") ||
          checkbox.getAttribute("data-varianttitle");

        // If no title, try to get it from nearby elements
        if (!title) {
          const titleElement = checkbox
            .closest(".extra-item")
            ?.querySelector(".extra-title, .variant-title, label");
          if (titleElement) {
            title = titleElement.textContent.trim();
          }
        }

        // add item for first order setup fee
        const additionalVariantId = checkbox.dataset.additionalVariantId;
        const subscriptionPurchaseCheckbox = document.getElementById('subscription-purchase');
        const defaultVariantId = subscriptionPurchaseCheckbox.dataset.extraSetupDefaultId;
        console.log("getExtraItems checkbox.value ====>", checkbox.value);
        console.log("getExtraItems defaultVariantId ====>", defaultVariantId);
        let extraItem = {
          id: checkbox.value,
          title: title || `Extra ${checkbox.value}`,
          qty: checkbox.dataset.type === "each" ? selectedVariantsItemsNumber : 1,
          type: checkbox.dataset.type,
          fileUrl: fileUrl || "",
          additionalVariantId: additionalVariantId,
          productId: checkbox.dataset.productId
        };

        if(subscriptionPurchaseCheckbox.checked && additionalVariantId && defaultVariantId) {
          console.log("getExtraItems defaultVariantId ====>", defaultVariantId);
          extraItem.id = defaultVariantId;
        }

        if (selectedVariantsItemsNumber > 1) {
          if (additionalVariantId) {
            // add item for second item first order setup fee
            const AdditionalVariantId = subscriptionPurchaseCheckbox.dataset.extraSetupAdditionalId;
            const additionalItem = {
              id: additionalVariantId,
              title: title || `Extra ${checkbox.value}`,
              qty: selectedVariantsItemsNumber - 1,
              type: "additional",
              productId: checkbox.dataset.productId
            }
            if(subscriptionPurchaseCheckbox.checked && AdditionalVariantId) {
              console.log("getExtraItems AdditionalVariantId ====>", AdditionalVariantId);
              additionalItem.id = AdditionalVariantId;
            }
            console.log("getExtraItems additionalItem ====>", additionalItem);
            extraItems.push(additionalItem);
          }
        }
        console.log("getExtraItems extraItem ====>", extraItem);
        extraItems.push(extraItem);
      }
    });
    console.log("getExtraItems extraItems ====>", extraItems);
    return {
      extraItems,
      isFileMissing
    };
  }

  function updateExtraItems() {
    const extraItems = getExtraItems();
    const titles = extraItems.extraItems.map((item, index) => {
      return index === extraItems.extraItems.length - 1 ? item.title : `${item.title},`;
    });
    if (extrasButton && extrasButton.querySelector("span")) {
      extrasButton.querySelector("span").textContent = titles.join(" ");
    }
  }
});

const lipBalmDummySellingPlan = [
  {
    "node": {
      "id": "gid://shopify/SellingPlan/6268551396",
      "name": "Daily Subscription",
      "description": "",
      "billingPolicy": {
        "intervalCount": 1
      },
      "options": [
        {
          "name": "Delivery every",
          "value": "1DAY1DAYMIN_CYCLES=NULLMAX_CYCLES=NULLfalsefalseDaily Subscription"
        }
      ],
      "recurringDeliveries": true,
      "priceAdjustments": []
    }
  }
]

const lipBalmDummyExtraSellingPlan = [
  {"id": "gid://shopify/Product/8728306483428",
    "sellingPlans": [
      {
        "node": {
          "id": "gid://shopify/SellingPlan/6268551396",
          "name": "Daily Subscription",
          "description": "",
          "billingPolicy": {
            "intervalCount": 1
          },
          "options": [
            {
              "name": "Delivery every",
              "value": "1DAY1DAYMIN_CYCLES=NULLMAX_CYCLES=NULLfalsefalseDaily Subscription"
            }
          ],
          "recurringDeliveries": true,
          "priceAdjustments": []
        }
      }
    ]
  },
  {"id": "gid://shopify/Product/8879916417252",
    "sellingPlans": [
      {
        "node": {
          "id": "gid://shopify/SellingPlan/6268551396",
          "name": "Daily Subscription",
          "description": "",
          "billingPolicy": {
            "intervalCount": 1
          },
          "options": [
            {
              "name": "Delivery every",
              "value": "1DAY1DAYMIN_CYCLES=NULLMAX_CYCLES=NULLfalsefalseDaily Subscription"
            }
          ],
          "recurringDeliveries": true,
          "priceAdjustments": []
        }
      }
    ]
  }
]

function appendLipBalmDummySellingPlan() {
  const optListElm = document.getElementById("subscription-option");
  const subscriptionPurchaseCheckbox = document.getElementById('subscription-purchase');
  lipBalmDummySellingPlan.forEach(sellingPlan => {
    optListElm.appendChild(new Option(sellingPlan.node.name, sellingPlan.node.id, false, false));
  });
  window.mainSellingPlanGroup = lipBalmDummySellingPlan;
  window.extraSellingPlans = lipBalmDummyExtraSellingPlan;
  subscriptionPurchaseCheckbox.disabled = false;
}

async function appendSellingPlanIdToProduct() {
  try {
    console.log("appendSellingPlanIdToProduct ====>");
    const subscriptionPurchaseCheckbox = document.getElementById('subscription-purchase');
    const optListElm = document.getElementById("subscription-option");
    const elmMainProduct = document.querySelector(".custom-bulk-order-flow");
    const extraFirstorderInput = document.getElementById('extra-item-1');
    const extraReorderInput = document.getElementById('extra-item-re-order');
    const extraItem2Input = document.getElementById('extra-item-2');
    const elmProductIds = [];
    const productIds = [];
    let mainId = "";
    if (elmMainProduct) {
      const productId = elmMainProduct.getAttribute('data-product-id');
      mainId = "gid://shopify/Product/" + productId
      elmProductIds.push({
        type: "main",
        id: "gid://shopify/Product/" + productId
      });
      productIds.push("gid://shopify/Product/" + productId);
    }
    if (extraFirstorderInput) {
      const id = extraFirstorderInput.getAttribute('data-product-id')
      if (id) {
        elmProductIds.push({
          type: "extra",
          id: "gid://shopify/Product/" + id
        });
        productIds.push("gid://shopify/Product/" + id);
      }
    }

    if (extraReorderInput) {
      const id = extraReorderInput.getAttribute('data-product-id')
      if (id) {
        elmProductIds.push({
          type: "extra",
          id: "gid://shopify/Product/" + id
        });
        productIds.push("gid://shopify/Product/" + id);
      }
    }
    if (extraItem2Input) {
      const id = extraItem2Input.getAttribute('data-product-id')
      if (id) {
        elmProductIds.push({
          type: "extra",
          id: "gid://shopify/Product/" + id
        });
        productIds.push("gid://shopify/Product/" + id);
      }
    }
    const sellingPlanIdsResponse =
      await nativeFetch('https://cqxj5vuftwa2hvmiqrjvzvkgke0waqee.lambda-url.us-east-1.on.aws/subscriptions', {
        method: 'POST',
        headers: {
          'x-token': "YkFyb2thaDEzPw==",
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ productIds: productIds })
      })
    const result = await sellingPlanIdsResponse.json();
    console.log("result ====>", result);
    if (result && result.status === "OK") {
      const mainSellingPlanGroup = result.sellingPlanGroups.find(edge => edge?.id === mainId)
      const extraSellingPlanGroup = result.sellingPlanGroups.filter(edge => edge?.id !== mainId)
      console.log("mainSellingPlanGroup ====>", mainSellingPlanGroup);
      console.log("extraSellingPlanGroup ====>", extraSellingPlanGroup);
      if (
        !mainSellingPlanGroup
        || !extraSellingPlanGroup
        || mainSellingPlanGroup.sellingPlanGroups?.edges.length === 0
        || extraSellingPlanGroup.sellingPlanGroups?.edges.length === 0
        || mainSellingPlanGroup.sellingPlanGroups?.edges[0]?.node?.sellingPlans?.edges.length === 0
        || extraSellingPlanGroup.sellingPlanGroups?.edges[0]?.node?.sellingPlans?.edges.length === 0
      ) {
        subscriptionPurchaseCheckbox.disabled = true;
        return;
      }
      if (mainSellingPlanGroup) {
        const sellingPlans = mainSellingPlanGroup.sellingPlanGroups?.edges[0]?.node?.sellingPlans?.edges;
        if (sellingPlans) {
          sellingPlans.forEach((sellingPlan, index) => {
            const sellingPlanId = sellingPlan.node.id;
            const sellingPlanName = sellingPlan.node.name;
            optListElm.appendChild(new Option(sellingPlanName, sellingPlanId, false, index === 0 ? true : false));
          });
          if (window && !window.mainSellingPlanGroup) {
            window.mainSellingPlanGroup = sellingPlans;
          }
        }
      }
      if (extraSellingPlanGroup && extraSellingPlanGroup[0] !== null && extraSellingPlanGroup.length > 0) {
        const extraSellingPlans = [];
        extraSellingPlanGroup.forEach(sellingPlanGroup => {
          const sellingPlans = sellingPlanGroup.sellingPlanGroups?.edges[0]?.node?.sellingPlans?.edges;
          extraSellingPlans.push({
            id: sellingPlanGroup.id,
            title: sellingPlanGroup.title,
            sellingPlans: sellingPlans
          })
        });
        if (window && !window.extraSellingPlans) {
          window.extraSellingPlans = extraSellingPlans;
        }
      }
      subscriptionPurchaseCheckbox.disabled = false;
    }
  } catch (error) {
    console.error("Error getting selling plan id", error);
  }
}